import PropTypes from "prop-types";
import React from "react";
import ProductgridList from "./ProductgridList";

const ShopProducts = ({ products, layout }) => {
  return (
    <div className="shop-bottom-area mt-3">
      <div className={`row ${layout ? layout : ""}`}>
		  {products.length ? <ProductgridList products={products} spaceBottomClass="mb-3" />:<div className="no-products-text">No Products Found</div>}
      </div>
    </div>
  );
};

ShopProducts.propTypes = {
  layout: PropTypes.string,
  products: PropTypes.array
};

export default ShopProducts;
